import React from 'react'
import PropTypes from 'prop-types'
import { Grid, IconButton, Typography } from '@material-ui/core'
import { SwitchUser } from "../img";
import { ChooseAccount } from './DocDialogs'
import { withStyles } from '@material-ui/core/styles'
import { QRCode } from "react-qr-svg";
import DelegateStore from '../stores/DelegateStore'
import { CustomTooltip } from './CustomTooltip';
import extract_user from '../functions/extract'

const styles = theme => ({
  sign: {
    height: "101px",
    display: "flex",
    "@media (max-width: 960px)": {
      justifyContent: "left",
      alignItems: "left",
    }
  },
  normal:{
    margin: "10px 0px 20px 0px"
  },
  adjust:{
    margin: "0px",
    height: "70px",
  },
  footer_text:{
    margin:"15px 0px 20px 0px"
  },
  footer_text_preview:{
    margin:"0px"
  },
  slogan:{
    textTransform: "uppercase"
  },
});

export const Sign = withStyles(styles, { withTheme: true })(
  ({ signed, sign, classes, preview, user, DateAndTimeDoc }) => {
    const short_user = user.email.substring(0, user.email.indexOf('@'));
    const sender = user.name.full +', '+ short_user +', '+ DateAndTimeDoc
    return (
      <div className={preview? classes.sign + " " + classes.adjust : classes.sign + " " + classes.normal}>
        { signed || preview? <QRCode style={{ width: preview? 50 : 100 }} value={sender} level="L" /> :
          <Typography variant="h6" className="pending_sign">
            Pendiente de firma
          </Typography>
        }
      </div>
    );
  }
);

class DocFooter extends React.Component {
  state = {
    open: false,
    users: []
  };

  filterUsers = () => {
    const { doc_id, check_replier, can_create, docStatus, role, user_id, from } = this.props;

    if(doc_id !== 'undefined'){
      if(check_replier){
        DelegateStore.getUsersOnReviewerReply(doc_id).then(r => {
              this.setState({ users: r.data });
        });
      }
      else{
        DelegateStore.getUsersOnBehalf().then(r => {
          const list = r.data;
          //si no tengo permiso para firmar, el oficio esta en edicion, soy el creador del oficio, quito a mi usuario,
          //dejo solo a los que me delegaron y asigno al primer usuario de la lista como emisor del oficio nuevo
            if(can_create === "false" && docStatus === 'inEdition' && role === 'owner' ){
              this.setState({ users: list.filter( l => l.id !== Number(user_id))});
              this.props.onSwitchFrom(this.state.users[0]);
          }

          //si no tengo permiso para firmar y el oficio esta en edicion quito a mi usuario y dejo solo a los que me delegaron(considera los borradores)
          if(can_create === "false" && docStatus === 'inEdition') {
              this.setState({ users: list.filter( l => l.id !== Number(user_id)) });
          }

          //si el documento fue rechazado solo dejo en la lista al usuario que me delegó ese oficio
          if(docStatus === 'rejected'){
            this.setState({ users: list.filter( l => l.id === Number(from.id)) });
          }

          //si el documento esta en edicion y tengo permiso para crear no quito a ningun usuario
          if(can_create === "true" && docStatus === 'inEdition'){
              this.setState({ users: list });
          }

        });
      }
    }

  }

  componentDidMount() {
    this.filterUsers()
  }

  componentDidUpdate(){
    this.filterUsers()
  }

  shouldComponentUpdate(nextProps, nextState) {
    return (
      this.props.url !== nextProps.url ||
      this.props.address.id !== nextProps.address.id ||
      this.props.from.id !== nextProps.from.id ||
      this.props.created_by.id !== nextProps.created_by.id ||
      this.state.open !== nextState.open ||
      this.props.role !== nextProps.role ||
      this.props.docStatus !== nextProps.docStatus ||
      this.state.users.length !== nextState.users.length ||
      this.props.doc_id !== nextProps.doc_id ||
      this.props.check_replier !== nextProps.check_replier
    );
  }

  openAccountsDialog = () => {
    this.setState({ open: true });
  };

  closeAccountsDialog = () => {
    this.setState({ open: false });
  };

  handleSelect = user => {
    this.props.onSwitchFrom(user);
    this.closeAccountsDialog();
  };

  render() {
    const { from, created_by, disabled, showSign, classes, slogan, preview, DateAndTimeDoc, address, telephone } = this.props;
    const { open, users } = this.state;
    let accountButton = null;

    if(users.length > 1 && !disabled){
      accountButton = (
        <CustomTooltip placement="right" title="Cambiar emisor">
          <IconButton onClick={this.openAccountsDialog}>
            <SwitchUser />
          </IconButton>
      </CustomTooltip>
      );
    }

    return (
      <Grid container>
        <Grid container>
          <Grid item sm={12} md={6} lg={6} xs={12} className={preview? "preview_text bold" : "bold"}>
            <Grid item>A T E N T A M E N T E</Grid>
            <Grid item
              className={classes.slogan + " " + (preview? classes.footer_text_preview : classes.footer_text)}
              style={{ marginBottom: preview ? 30 : 50 }}>{slogan}</Grid>
            <Grid item className={preview || disabled? classes.footer_text_preview : classes.footer_text}>{((typeof from.job_title !== 'undefined') && (from.job_title !== null))? from.job_title : ' ' }</Grid>
            <Grid item className={preview || disabled? classes.footer_text_preview : classes.footer_text} style={{ marginTop: preview || disabled ? 0 : '-11px'}}>{((typeof from.department !== 'undefined') && (from.department !== null))? from.department : ' ' }</Grid>
            <Grid item className={preview || disabled? classes.footer_text_preview : classes.footer_text} style={{ marginTop: preview || disabled ? 0 : '-11px'}}>{from.institution}</Grid>
            <Grid item>
              <Sign signed={showSign} preview={preview} user={from} DateAndTimeDoc={DateAndTimeDoc}/>
            </Grid>
          </Grid>
        </Grid>
        <Grid container justify="space-between" direction="row" alignItems="flex-start">
          <Grid item className="bold" >
            {from.name.title + " " + from.name.full}
            {accountButton}
          </Grid>
          <Grid item  sm={7} md={7} lg={7} xs={7} xl={7}>
          </Grid>
          <Grid item  sm={12} md={5} lg={5} xs={5} xl={5} className={preview? "preview_text right" : "footer_text right"}>
            <Grid item className={preview? "preview_text institution" : "institution" } >
              {`${from.institution} | ${((typeof from.department !== 'undefined') && (from.department !== null))? from.department : ' '}`}
            </Grid>
            <Grid item>{`${address.street}, ${address.colony}, CP: ${address.zip}, ${address.city}`}</Grid>
            <Grid item>{`${(telephone === null)? '' :  'Tel. ' + telephone.number + ', Ext. ' + telephone.ext }`}</Grid>
            <Grid item style={{ paddingTop: '1em', paddingBottom: '1em' }}>Creado por: {((typeof created_by.name.title !== 'undefined')? created_by.name.title + ' ' : '' ) + created_by.name.full} ({extract_user(created_by.email)})</Grid>
          </Grid>
        </Grid>
        {from !== created_by ?
         <ChooseAccount
           open={open}
           handleClose={this.closeAccountsDialog}
           handleSelect={this.handleSelect}
           users={users}
         />
       : null}
      </Grid>
    );
  }
}

DocFooter.propTypes = {
  address: PropTypes.object.isRequired,
  from: PropTypes.object.isRequired,
  created_by: PropTypes.object.isRequired,
  onSwitchFrom: PropTypes.func.isRequired,
  showSign: PropTypes.bool.isRequired
};
export default withStyles(styles)(DocFooter);



// WEBPACK FOOTER //
// ./src/components/DocFooter.js